import React from 'react';
import ContractBody from './ContractBody';

interface Props {
    settings: any;
    coaches: any[];
    /** false = Bestandskunde, true = Neukunde */
    isNewCustomer?: boolean;
}

/** Onboarding-Vorentwurf: PEOne TeamBase (ohne MA-Auswertung) */
const ContractPreviewBasic: React.FC<Props> = ({ settings, coaches, isNewCustomer }) => (
    <ContractBody
        settings={settings}
        coaches={coaches}
        selectedPackage="teamBase"
        variant="preview"
        includeHeader
        isNewCustomer={isNewCustomer}
    />
);

export default ContractPreviewBasic;
